import { downloadCsv, type CsvColumn } from "@/lib/csv";
import { daysUntil } from "@/lib/format";
import { editionLabel, LICENSE_STATUS_META } from "@/lib/license";
import type { AdminLicense } from "@/pages/admin/hooks/useAdminData";

const columns: CsvColumn<AdminLicense>[] = [
  { key: "license_key", label: "许可证密钥", value: (row) => row.license_key },
  { key: "product_name", label: "产品名称", value: (row) => row.product_name },
  { key: "edition", label: "版本类型", value: (row) => editionLabel(row.edition) },
  { key: "status", label: "状态", value: (row) => LICENSE_STATUS_META[row.status]?.label ?? row.status },
  { key: "seat_count", label: "授权席位", value: (row) => row.seat_count },
  { key: "activation_count", label: "已激活", value: (row) => row.activation_count },
  { key: "max_activations", label: "最大激活数", value: (row) => row.max_activations },
  { key: "issued_at", label: "签发时间", value: (row) => formatDateCell(row.issued_at) },
  { key: "expires_at", label: "到期时间", value: (row) => (row.expires_at ? formatDateCell(row.expires_at) : "永久") },
  {
    key: "days_left",
    label: "剩余天数",
    value: (row) => (row.expires_at ? daysUntil(row.expires_at) : ""),
  },
  { key: "user_id", label: "用户 ID", value: (row) => row.user_id ?? "" },
  { key: "application_id", label: "申请编号", value: (row) => row.application_id ?? "" },
];

function formatDateCell(input: string | null): string {
  if (!input) return "";
  const date = new Date(input);
  if (Number.isNaN(date.getTime())) return "";
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
}

export function downloadAdminLicenseReport(licenses: AdminLicense[]): number {
  const stamp = new Date().toISOString().slice(0, 10);
  downloadCsv(`许可证全量报表_${stamp}.csv`, columns, licenses);
  return licenses.length;
}